import React, { FC } from 'react'
import PaginationButtons from '../../../../PaginationButtons'
import FhirLoader from '../../../../FhirLoader'
import { ConditionBundle } from '../../../../../types/FHIRTypes/Bundle'
import { isConditionBundle } from '../../../../../typeGuards/fhirTypes'
import { ConditionTable } from '@teschglobal/tg-fhir-react-components'

type ConditionListProps = {
    conditionData: ConditionBundle;
    isFetching: boolean;
    handleChangePage: (page: number) => void
    totalPages: number;
    currentPage: number;
}

const ConditionList: FC<ConditionListProps> = ({ conditionData, handleChangePage, isFetching, totalPages, currentPage }) => {
    if (!isConditionBundle(conditionData)) return null

    const patientConditions = conditionData && conditionData.entry ? conditionData.entry.map((condition) => condition.resource) : []

    if (isFetching) {
        return <FhirLoader message='Loading...' />
    }

    return (
        <>
            {
                conditionData?.total > 0 && (
                    <div className='my-3 fw-bold'>
                        <span role="status" aria-live="polite">{conditionData?.total.toLocaleString()} record(s) found</span>
                        <PaginationButtons
                            totalPages={totalPages}
                            currentPage={currentPage}
                            handleChangePage={handleChangePage}
                        />
                    </div>
                )
            }
            <ConditionTable
                conditions={patientConditions}
            />
            {
                conditionData?.total > 0 && (
                    <div className='my-3 fw-bold'>
                        <PaginationButtons
                            totalPages={totalPages}
                            currentPage={currentPage}
                            handleChangePage={handleChangePage}
                        />
                    </div>
                )
            }
        </>
    )
}

export default ConditionList